<!-- 弹窗组件 Modal.vue -->
<template>
    <div class="modal" v-if="visible" @click.self="close">
      <div class="modal-container">
        <div class="modal-content">
          <slot></slot>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        visible: false,
      };
    },
    methods: {
      open() {
        this.visible = true;
      },
      close() {
        this.visible = false;
      },
    },
  };
  </script>
  
  <style scoped>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    transition: all 0.3s ease-in-out;
  }
  
  .modal-container {
    width: 80%;
    max-width: 500px;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
  }
  
  .modal-content {
    padding: 20px;
  }
  </style>
  